import Assert from '../utils/Assert';
// import MetroCode from './MetroCode';

export default class Capacity {
  constructor(metroCode, datacenters, cabETotal, cabEAvailable, capacityTotal, capacityAvailable, capacityAvailableMax, capacityAverage, isCoolingAvailable) {
    // Assert.instanceOf(metroCode, MetroCode);
    Assert.isString(metroCode);
    Assert.isInteger(datacenters);
    Assert.isNumber(cabETotal);
    Assert.isNumber(cabEAvailable);
    Assert.isNumber(capacityTotal);
    Assert.isNumber(capacityAvailable);
    Assert.isNumber(capacityAvailableMax);
    Assert.isNumber(capacityAverage);
    Assert.isBoolean(isCoolingAvailable);

    this.metroCode = metroCode;
    this.datacenters = datacenters;
    this.cabETotal = cabETotal;
    this.cabEAvailable = cabEAvailable;
    this.capacityTotal = capacityTotal;
    this.capacityAvailable = capacityAvailable;
    this.capacityAvailableMax = capacityAvailableMax;
    this.capacityAverage = capacityAverage;
    this.isCoolingAvailable = isCoolingAvailable;
    Object.freeze(this);
  }

  equals(other) {
    if (!(other instanceof Capacity)) {
      return false;
    }

    // return this.metroCode.equals(other.metroCode);
    return this.metroCode === other.metroCode;
  }

  toString() {
    return `${this.constructor.name}{ metroCode:'${this.metroCode}', datacenters:${this.datacenters}, cabETotal:${this.cabETotal}, cabEAvailable:${this.cabEAvailable}, capacityTotal:${this.capacityTotal}, capacityAvailable:${this.capacityAvailable}, capacityAvailableMax:${this.capacityAvailableMax}, capacityAverage:${this.capacityAverage}, isCoolingAvailable:${this.isCoolingAvailable} }`;
  }

  toJSON() {
    const {
      metroCode,
      datacenters,
      cabETotal,
      cabEAvailable,
      capacityTotal,
      capacityAvailable,
      capacityAvailableMax,
      capacityAverage,
      isCoolingAvailable,
    } = this;
    return { metroCode, datacenters, cabETotal, cabEAvailable, capacityTotal, capacityAvailable, capacityAvailableMax, capacityAverage, isCoolingAvailable };
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    const {
      metroCode,
      datacenters,
      cabETotal,
      cabEAvailable,
      capacityTotal,
      capacityAvailable,
      capacityAvailableMax,
      capacityAverage,
      isCoolingAvailable,
    } = json;

    return new Capacity(
      metroCode,
      datacenters,
      cabETotal,
      cabEAvailable,
      capacityTotal,
      capacityAvailable,
      capacityAvailableMax,
      capacityAverage,
      isCoolingAvailable
    );
    // isCoolingAvailable, new MetroCode(metroCode));
  }

  static fromJSONArray(jsonArray) {
    if (!jsonArray) {
      return [];
    }

    const items = [];
    for (const json of jsonArray) {
      const p = Capacity.fromJSON(json);
      items.push(p);
    }

    return items;
  }
}
